/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A fee of the quote in a validation snapshot.
 * @export
 * @interface DevisPhotoFrais
 */
export interface DevisPhotoFrais {
    /**
     * 
     * @type {string}
     * @memberof DevisPhotoFrais
     */
    remunerationDevisId: string;
    /**
     * 
     * @type {string}
     * @memberof DevisPhotoFrais
     */
    libelle?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevisPhotoFrais
     */
    montantTtc: number;
}

/**
 * Check if a given object implements the DevisPhotoFrais interface.
 */
export function instanceOfDevisPhotoFrais(value: object): value is DevisPhotoFrais {
    if (!('remunerationDevisId' in value) || value['remunerationDevisId'] === undefined) return false;
    if (!('montantTtc' in value) || value['montantTtc'] === undefined) return false;
    return true;
}

export function DevisPhotoFraisFromJSON(json: any): DevisPhotoFrais {
    return DevisPhotoFraisFromJSONTyped(json, false);
}

export function DevisPhotoFraisFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevisPhotoFrais {
    if (json == null) {
        return json;
    }
    return {
        
        'remunerationDevisId': json['remunerationDevisId'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'montantTtc': json['montantTtc'],
    };
}

export function DevisPhotoFraisToJSON(json: any): DevisPhotoFrais {
    return DevisPhotoFraisToJSONTyped(json, false);
}

export function DevisPhotoFraisToJSONTyped(value?: DevisPhotoFrais | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remunerationDevisId': value['remunerationDevisId'],
        'libelle': value['libelle'],
        'montantTtc': value['montantTtc'],
    };
}

